import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import {
  initialNumberFormat,
  NumberFormat,
  NumberFormatOptions,
  numberFormatSeparators,
} from 'shared/types/number-format-options';

const getAutoSeparators = (): NumberFormat => {
  const locale = navigator.language || 'en-US';
  const parts = new Intl.NumberFormat(locale).formatToParts(1234.5);
  const decimal = parts.find((part) => part.type === 'decimal')?.value || '.';
  const group = parts.find((part) => part.type === 'group')?.value || ',';
  return { decimal, group };
};

export const useNumberFormat = (): NumberFormat => {
  const user = useUser();
  const format = user?.settings?.numberFormat ?? initialNumberFormat;

  return useMemo(() => {
    if (format === NumberFormatOptions.Auto) {
      return getAutoSeparators();
    }
    return numberFormatSeparators[format];
  }, [format]);
};
